var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg61(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M31.33,37.95c-8.39,0-13.4-5.04-13.4-13.48,0-12.25,5.93-19.28,16.28-19.28,6.86,0,11.65,3.65,12.5,9.51l.28,1.97-5.01,.76c2.15,1.78,3.38,4.56,3.38,8.04,0,7.58-5.51,12.48-14.04,12.48Zm.44-12.64c-.43,0-1.16,0-1.16,1.92,0,.25,.05,.37,.07,.39,.02,0,.12,.05,.33,.05,.64,0,1.2,0,1.2-1.88,0-.25-.03-.4-.06-.45h-.01s-.16-.02-.37-.02Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M43.37,25.47c0,6.68-4.76,10.48-12.04,10.48-8.24,0-11.4-5.08-11.4-11.48,0-9.88,4.12-17.28,14.28-17.28,6.12,0,9.84,3.08,10.52,7.8l-9,1.36c-.08-1.84-.76-2.84-2.32-2.84-2.92,0-4.08,3-4.52,6.84,1.56-2.08,3.84-3.08,6.52-3.08,4.84,0,7.96,3.08,7.96,8.2Zm-9.16,.32c0-1.64-.84-2.48-2.44-2.48-2.32,0-3.16,1.8-3.16,3.92,0,1.44,.84,2.44,2.4,2.44,2.4,0,3.2-1.64,3.2-3.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg61);
export default __webpack_public_path__ + "static/media/6_1.271d740d79772db0c64d105f9feb508e.svg";
export { ForwardRef as ReactComponent };